let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")

let CoinMatchBackPopupAction = xClass("CoinMatchBackPopupAction", HomeScenePopoutAction)

CoinMatchBackPopupAction.prototype.ctor = function(lastLvStep) {
    HomeScenePopoutAction.prototype.ctor.call(this);
    this.lastLvStep = lastLvStep;
}
CoinMatchBackPopupAction.prototype.id = function() {
    return HomeScenePopoutEnum.kCoinMatchLevelEndActivityAction
}
CoinMatchBackPopupAction.prototype.trigger = function(eventName) {   
    if (eventName == HomeSceneActCondition.kCoinMatchExitLevel) {
        let scene = cc.Director.getInstance().getRunningScene();
        if (!scene || scene.name !== 'HomeScene') {
            LogToLogCenter(new Error("CoinMatchBackPopupAction trigger in scene:" + (scene == null? "null": scene.name)));
            return false;
        } 
    
        return true;
    }
    return false;
}
CoinMatchBackPopupAction.prototype.run = function () {
    CoinMatchLogic.show(null, null, null, true, this.lastLvStep);
    this.lastLvStep = null;
    this.complete();
}

module.exports = CoinMatchBackPopupAction